<template>
    <form @submit.prevent="submitForm">
        <div class="form-control" :class="{ invalid: !name.isValid }">
            <label for="name">Name *</label>
            <input id="name" v-model.trim="name.val" type="text" @blur="clearValidity('name')" />
            <p v-if="!name.isValid">Name must not be empty.</p>
        </div>
    
        <div class="form-control" :class="{ invalid: !mobile.isValid }">
            <label for="mobile">Mobile *</label>
            <input id="mobile" v-model.trim="mobile.val" type="text" @blur="clearValidity('mobile')">
            <p v-if="!mobile.isValid">Mobile number must not be empty.</p>
        </div>
    
        <!-- Masked password -->
        <div class="form-control" :class="{ invalid: !password.isValid }">
            <label for="password">Password </label>
            <input id="password" v-model.trim="password.val" type="password" @blur="clearValidity('password')" @copy.prevent
                @paste.prevent>
            <p v-if="!password.isValid">Password must not be empty.</p>
        </div>
    
        <!-- Clear text password -->
        <div class="form-control" :class="{ invalid: !passwordClear.isValid }">
            <label for="password-clear">Retype Password</label>
            <input id="password-clear" v-model.trim="passwordClear.val" type="text" @blur="clearValidity('passwordClear')"
                @copy.prevent @paste.prevent>
            <p v-if="!passwordClear.isValid">Password must not be empty.</p>
        </div>
    
        <!-- Match error -->
        <p v-if="password.val && passwordClear.val && password.val !== passwordClear.val" style="color:red;">
            Passwords do not match.
        </p>
        <base-button>Register</base-button>
    
        <p style="margin-top: 1rem;">
            Already have an account?
            <router-link to="/login">Login</router-link>
        </p>
        <!-- show API response -->
        <p :class="apiStatus">{{ apiMessage }}</p>
    </form>
</template>
  
<script>
export default {
  emits: ['save-data'],
  data() {
    return {
      name: { val: '', isValid: true },
      email: { val: '' },
      mobile: { val: '', isValid: true },
      password: { val: '', isValid: true },
      passwordClear: { val: '', isValid: true },
      formIsValid: true,
      apiMessage: '',
      apiStatus: '' // "success" or "error"
    };
  },
  methods: {
    clearValidity(input) {
      this[input].isValid = true;
    },
    validateForm() {
      this.formIsValid = true;

      // Name validation
      if (!this.name.val) {
        this.name.isValid = false;
        this.formIsValid = false;
      }

      // Mobile validation (10 digits only)
      const mobileRegex = /^[0-9]{10}$/;
      if (!mobileRegex.test(this.mobile.val)) {
        this.mobile.isValid = false;
        this.formIsValid = false;
      }

      // Password validation
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/;
      if (!passwordRegex.test(this.password.val)) {
        this.password.isValid = false;
        this.formIsValid = false;
      }
    },
    async submitForm() {
      this.validateForm();
      if (!this.formIsValid) return;
      if (this.password.val !== this.passwordClear.val) {
        alert('Passwords do not match')
        return
      }
      const formData = {
        name: this.name.val,
        email: this.email.val || null,
        mobile: this.mobile.val,
        password: this.password.val,
      };

      try {
        const res = await this.$store.dispatch('users/registerUser', formData);
        const message = typeof res === 'string' ? res : res?.data;

        if (message === 'Registered Successfully') {
          this.apiMessage = message;
          this.apiStatus = 'success';
          setTimeout(() => {
            this.$router.push('/login');
          }, 1500);
        } else {
          this.apiMessage = message;
          this.apiStatus = 'error';
        }
      } catch (err) {
        this.apiMessage = err.response?.data || 'Registration failed';
        this.apiStatus = 'error';
      }
    }
  }
};
</script>

<style scoped>
.form-control {
    margin: 0.5rem 0;
}

label {
    font-weight: bold;
    display: block;
    margin-bottom: 0.5rem;
}

input {
    display: block;
    width: 50%;
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 0.5rem;
    font: inherit;
    transition: all 0.3s ease;
    box-sizing: border-box;
}

input:focus {
    background-color: #f0e6fd;
    outline: none;
    border-color: #3d008d;
}

.invalid label {
    color: red;
}

.invalid input {
    border: 1px solid red;
}

.success {
    color: green;
}

.error {
    color: red;
}
</style>
